import { createTheme } from "@mui/material/styles";
import { css } from "@mui/material";
import { createElement } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { layout } from "./layout";
import { LinkWrapper } from "./link-wrapper";
import { palette } from "./palette";


export const theme = createTheme({
	palette,
	typography: {
		h1: {
			fontWeight: 500,
			fontSize: "2.5rem",
		},
		h2: {
			fontWeight: 500,
			fontSize: "2rem",
		},
		h3: {
			fontWeight: 500,
			fontSize: "1.5rem",
		},
		h4: {
			fontWeight: 500,
		},
		h5: {
			fontWeight: 500,
		},
		body1: {
			fontSize: "1rem",
		},
		body2: {
			fontSize: ".9rem",
		},
		button: {
			textTransform: "none",
			whiteSpace: "nowrap",
			fontSize: "1.05rem",
		},
		caption: {
			lineHeight: "1",
		},
	},
	shape: {
		borderRadius: 8,
	},
	layout,
	components: {
		MuiAutocomplete: {
			defaultProps: {
				openOnFocus: true,
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					overflow: "hidden",
				},
			},
		},
		MuiButtonBase: {
			defaultProps: {
				LinkComponent: LinkWrapper,
				focusRipple: true,
			},
		},
		MuiButton: {
			defaultProps: {
				variant: "contained",
			},
		},
		MuiFab: {
			defaultProps: {
				size: "small",
			},
		},
		MuiTextField: {
			defaultProps: {
				size: "small",
			},
		},
		MuiStack: {
			defaultProps: {
				spacing: 2,
			},
		},
		MuiTableCell: {
			defaultProps: {
				padding: "none",
			},
			styleOverrides: {
				root: {
					padding: 8,
				},
			},
		},
		MuiChip: {
			defaultProps: {
				size: "small",
			},
			variants: [
				{
					props: { variant: "outlined", color: "dark" },
					style: ({ theme }) => css`
						color: ${theme.palette.dark.contrastText};
						border-color: ${theme.palette.grey[500]};
					`,
				},
			],
		},
		MuiAlert: {
			styleOverrides: {
				message: {
					flex: 1,
				},
			},
		},

		MuiAccordion: {
			defaultProps: {
				disableGutters: true,
			},
			styleOverrides: {
				root: {
					overflow: "hidden",
					"&.Mui-expanded": {
						minHeight: 0,
					},
				},
			},
		},
		MuiAccordionSummary: {
			defaultProps: {
				expandIcon: createElement(ExpandMoreIcon),
			},
		},
		MuiTooltip: {
			defaultProps: {
				disableInteractive: true,
			},
		},
		MuiDivider: {
			styleOverrides: {
				root: css`
					&.MuiDivider-horizontal {
						max-height: 1px;
					}
				`,
			},
		},
		MuiCard: {
			styleOverrides: {
				root: () => css`
					display: flex;
					flex-direction: column;
				`,
			},
		},
		MuiCardHeader: {
			styleOverrides: {
				root: ({ theme }) => css`
					padding: ${theme.spacing(1)};
					padding-block-end: 0;
				`,
			},
		},
		MuiCardContent: {
			styleOverrides: {
				root: ({ theme }) => css`
					padding: ${theme.spacing(1)};

					&:last-child {
						padding-bottom: ${theme.spacing(1)};
					}
				`,
			},
		},
		MuiSelect: {
			defaultProps: {
				size: "small",
			},
		},
		MuiButtonGroup: {
			defaultProps: {
				color: "primary",
			},
		},
		MuiToggleButtonGroup: {
			defaultProps: {
				color: "primary",
			},
		},
	},
});
